import { useNavigate, useParams } from 'react-router-dom'
import { Button } from '@/components/ui/button'
import { ArrowLeft } from 'lucide-react'
import { AutomationCanvas } from '@/components/automation-canvas/AutomationCanvas'

export function AutomationCanvasPage() {
  const navigate = useNavigate()
  const { lang, automationId } = useParams()

  return (
    <div className="fixed inset-0 z-[100] overflow-hidden bg-background">
      <div className="absolute left-4 top-4 z-50">
        <Button variant="outline" onClick={() => navigate(`/${lang}/actions`)}>
          <ArrowLeft className="mr-2 h-4 w-4" /> Volver
        </Button>
      </div>
      <AutomationCanvas
        automationName={automationId ? `Automation ${automationId}` : 'Nueva automatización'}
        onClose={() => navigate(`/${lang}/actions`)}
      />
    </div>
  )
}


